export enum BooleanComparator {
  DOES_NOT_EQUAL = 'DoesNotEqual',
  EQUALS = 'Equals',
}

export enum StringComparator {
  EQUALS = 'Equals',
  DOES_NOT_EQUAL = 'DoesNotEqual',
  IS_SET = 'IsSet',
  STARTS_WITH = 'StartsWith',
}

export enum NumericComparator {
  GREATER_THAN = 'GreaterThan',
  GREATER_THAN_OR_EQUAL = 'GreaterThanOrEqualTo',
  LESS_THAN = 'LessThan',
  LESS_THAN_OR_EQUAL = 'LessThanOrEqualTo',
  EQUALS = 'Equals',
  DOES_NOT_EQUAL = 'DoesNotEqual',
  IS_SET = 'IsSet',
}

export enum DateComparator {
  IS_AFTER = 'GreaterThan',
  IS_ON_OR_AFTER = 'GreaterThanOrEqualTo',
  IS_BEFORE = 'LessThan',
  IS_ON_OR_BEFORE = 'LessThanOrEqualTo',
  EQUALS = 'Equals',
  DOES_NOT_EQUAL = 'DoesNotEqual',
  BETWEEN = 'IsBetween',
  IS_SET = 'IsSet',
}

export enum GeoLocationComparator {
  IS_NOT_SET = 'IsNotSet',
  IS_SET = 'IsSet',
}

export enum IsWithinComparator {
  IS_WITHIN = 'LessThan',
}

export enum ListComparator {
  DOES_NOT_INCLUDE = 'DoesNotEqual',
  INCLUDES = 'Equals',
}

export enum ObjectComparator {
  IS_SET = 'IsSet',
  IS_NOT_SET = 'IsNotSet',
}

export enum BrandAffinityComparator {
  DOES_NOT_EQUAL = 'DoesNotEqual',
  EQUALS = 'Equals',
  IS_SET = 'IsSet',
}

export enum IsOneOfComparator {
  IS_ONE_OF = 'IsOneOf',
  IS_NOT_ONE_OF = 'IsNotOneOf',
}

export enum CampaignLabelsComparator {
  Equals = 'Equals',
}

export enum CampaignComparator {
  IS_ONE_OF = 'IsOneOf',
  IS_NOT_ONE_OF = 'IsNotOneOf',
  IS_SET = 'IsSet',
}

export enum MessageTypeComparator {
  DOES_NOT_EQUAL = 'DoesNotEqual',
  EQUALS = 'Equals',
}

export enum TemplateComparator {
  DOES_NOT_EQUAL = 'DoesNotEqual',
  EQUALS = 'Equals',
}

export enum RegexComparator {
  MATCHES_REGEX = 'MatchesRegex',
  CONTAINS = 'Contains',
}

export enum DefaultComparator {
  DOES_NOT_EQUAL = 'DoesNotEqual',
  EQUALS = 'Equals',
  STARTS_WITH = 'StartsWith',
  GREATER_THAN = 'GreaterThan',
  GREATER_THAN_OR_EQUAL = 'GreaterThanOrEqualTo',
  LESS_THAN = 'LessThan',
  LESS_THAN_OR_EQUAL = 'LessThanOrEqualTo',
  IS_SET = 'IsSet',
  IS_NOT_SET = 'IsNotSet',
}

type CustomComparator = string;

export type Comparator =
  | BooleanComparator
  | CampaignLabelsComparator
  | DateComparator
  | GeoLocationComparator
  | IsWithinComparator
  | ListComparator
  | NumericComparator
  | ObjectComparator
  | StringComparator
  | BrandAffinityComparator
  | IsOneOfComparator
  | CampaignComparator
  | TemplateComparator
  | MessageTypeComparator
  | RegexComparator
  | DefaultComparator;

export type AnyComparator = Comparator | CustomComparator;
